// @flow
import React from 'react';
import useNow from '../../../hooks/useNow';
import Duration from './Duration';

type Props = $ReadOnly<{
    timestamp: ?number
}>;

function DurationUntil({ timestamp }: Props) {
    const now = useNow();

    const duration = timestamp ? Math.max(0, timestamp - now) : null;

    return <Duration duration={duration} />;
}

export default DurationUntil;